'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var actionTypes = {
    CLEAR_NOTIFICATION: 'CLEAR_NOTIFICATION'
};

function clearNotification() {
    return {
        type: actionTypes.CLEAR_NOTIFICATION
    };
}

var actionCreators = {
    clearNotification: clearNotification
};

exports.actionTypes = actionTypes;
exports.actionCreators = actionCreators;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9jbGllbnQvYWN0aW9ucy9hcHAuanMiXSwibmFtZXMiOlsiYWN0aW9uVHlwZXMiLCJDTEVBUl9OT1RJRklDQVRJT04iLCJjbGVhck5vdGlmaWNhdGlvbiIsInR5cGUiLCJhY3Rpb25DcmVhdG9ycyJdLCJtYXBwaW5ncyI6Ijs7Ozs7QUFBQSxJQUFNQSxjQUFjO0FBQ2hCQyx3QkFBb0I7QUFESixDQUFwQjs7QUFJQSxTQUFTQyxpQkFBVCxHQUE2QjtBQUN6QixXQUFPO0FBQ0hDLGNBQU1ILFlBQVlDO0FBRGYsS0FBUDtBQUdIOztBQUVELElBQU1HLGlCQUFpQjtBQUNuQkY7QUFEbUIsQ0FBdkI7O1FBSVNGLFcsR0FBQUEsVztRQUFhSSxjLEdBQUFBLGMiLCJmaWxlIjoiYXBwLmpzIiwic291cmNlUm9vdCI6Ii9zcmMiLCJzb3VyY2VzQ29udGVudCI6WyJjb25zdCBhY3Rpb25UeXBlcyA9IHtcbiAgICBDTEVBUl9OT1RJRklDQVRJT046ICdDTEVBUl9OT1RJRklDQVRJT04nXG59O1xuXG5mdW5jdGlvbiBjbGVhck5vdGlmaWNhdGlvbigpIHtcbiAgICByZXR1cm4ge1xuICAgICAgICB0eXBlOiBhY3Rpb25UeXBlcy5DTEVBUl9OT1RJRklDQVRJT05cbiAgICB9O1xufVxuXG5jb25zdCBhY3Rpb25DcmVhdG9ycyA9IHtcbiAgICBjbGVhck5vdGlmaWNhdGlvblxufTtcblxuZXhwb3J0IHsgYWN0aW9uVHlwZXMsIGFjdGlvbkNyZWF0b3JzIH07Il19


//////////////////
// WEBPACK FOOTER
// ./src/client/actions/app.js
// module id = 759
// module chunks = 0